<script setup lang="ts">
import InvoiceReader from '@/components/Globals/InvoiceReader.vue'
import RateChart from '@/components/Rate/Chart/RateChart.vue'
import RateConsumptionAndDemandTable from '@/components/Rate/RateConsumptionAndDemandTable.vue'
import RateGroupTable from '@/components/Rate/RateGroupTable.vue'
import RateHeader from '@/components/Rate/RateHeader.vue'
import RateValues from '@/components/Rate/RateValues.vue'
import ComsuptionChart from '@/components/Report/Body/Chart/ComsuptionChart.vue'
import { FareItems } from '@/interfaces/entities/fareItems'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import { useRateStore } from '@/store/rate'

const { setFareData } = useRateStore()

function handleFareDataLoaded(fareData: FareItems) {
  setFareData(fareData)
}
</script>

<template>
  <DefaultLayout>
    <RateHeader />
    <div class="grid grid-cols-2 gap-6 p-6 lg:px-8">
      <InvoiceReader @fareDataLoaded="handleFareDataLoaded" />
      <RateValues />
    </div>
    <div class="flex flex-col p-6 lg:px-8">
      <RateConsumptionAndDemandTable />
    </div>

    <div class="flex flex-col p-6 lg:px-8">
      <RateGroupTable />
    </div>

    <div class="flex flex-col p-6 lg:px-8">
      <RateChart />
    </div>
  </DefaultLayout>
</template>
